import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;


export const addCarApi = createApi({
  reducerPath: "addCarApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({ 
    addCar: builder.mutation({
      query: (carData) => ({
        url: "/Car/add",
        method: "POST",
        body: carData,
      }),
    }),
 
    getAllCars: builder.query({
      query: () => ({
        url: "/Car/all-cars",
        method: "GET",
      }),
    }),

    deleteCar: builder.mutation({
      query: (id) => ({
        url: `/Car/delete/${id}`,
        method: "DELETE",
      }),
    }),
 
    updateCar: builder.mutation({
      query: (carData) => ({
        url: "/Car/update",
        method: "PUT",
        body: carData,
      }),
    }),
  }),
});
 
export const { 
  useAddCarMutation, 
  useGetAllCarsQuery, 
  useDeleteCarMutation, 
  useUpdateCarMutation  
} = addCarApi;
